import createReducer from 'utils/createReducer';
import {allOpt, periodOpts} from 'utils/dashboard';

const actionTypes = {
  setFilters: 'setFilters',
  setDates: 'setDates'
};

const initialState = {
  filters: {
    countries: [allOpt],
    cities: [allOpt],
    businessUnits: [allOpt],
    departments: [allOpt],
    sections: [allOpt],
    buildings: [allOpt],
    comparison: ''
  },
  dates: {
    ...periodOpts[1]
  }
};

const dashboardReducer = createReducer(initialState, {
  [actionTypes.setFilters]: (state, payload) => ({
    ...state,
    filters: {
      ...payload
    }
  }),
  [actionTypes.setDates]: (state, payload) => ({
    ...state,
    dates: {
      ...payload
    }
  })
});

export {actionTypes, dashboardReducer, initialState};
